// Shared by the endpoint and outside-label placements; media-pixel geometry.
export function drawAvwapAlarm(ctx, x, y, color) {
  ctx.save()
  ctx.globalAlpha = 0.6
  ctx.strokeStyle = color
  ctx.lineWidth = 1.2; ctx.lineCap = 'round'; ctx.lineJoin = 'round'
  ctx.beginPath(); ctx.arc(x,y,4,0,Math.PI*2); ctx.stroke()
  ctx.beginPath()
  ctx.moveTo(x,y-2); ctx.lineTo(x,y); ctx.lineTo(x+2,y+1)
  ctx.moveTo(x-5,y-4); ctx.lineTo(x-3,y-6)
  ctx.moveTo(x+3,y-6); ctx.lineTo(x+5,y-4)
  ctx.moveTo(x-2,y+4); ctx.lineTo(x-3,y+5)
  ctx.moveTo(x+2,y+4); ctx.lineTo(x+3,y+5)
  ctx.stroke(); ctx.restore()
}
